// extracted by mini-css-extract-plugin
export default {"styledGroupHeaderWrapper":"styled-group-header-module__styledGroupHeaderWrapper--cEUvd"};